import { formatDateParam } from './formatDateParam';

/**
 * Builds query string for date filters.
 * @param {Date | null} startDate - Start date.
 * @param {Date | null} endDate - End date.
 * @returns {string} Query string part for dates or empty string.
 */
export const buildDateQueryString = (startDate, endDate) => {
  const params = new URLSearchParams();
  const formattedStartDate = formatDateParam(startDate);
  const formattedEndDate = formatDateParam(endDate);
  if (formattedStartDate) {
    params.append('storeCreationStartDate', formattedStartDate);
  }
  if (formattedEndDate) {
    params.append('storeCreationEndDate', formattedEndDate);
  }
  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};
